import { Component, inject } from '@angular/core';
import { GroupingTypeOfVariableService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GroupingTypeOfVariableCreateDto,
  GroupingTypeOfVariableDto,
  GroupingTypeOfVariableExcelDownloadDto,
  GroupingTypeOfVariableUpdateDto,
} from '../proxy/controlling/dtos/grouping-type-of-variable';
import { GROUPINGTYPEOFVARIABLE_CONFIG, GROUPINGTYPEOFVARIABLE_FIELDS } from './grouping-type-of-variable.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-grouping-type-of-variable',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GroupingTypeOfVariableService, ConfirmationService],
  templateUrl: './grouping-type-of-variable.html',
  styleUrl: './grouping-type-of-variable.scss',
})
export class GroupingTypeOfVariable extends BaseCrudComponent<
  GroupingTypeOfVariableDto,
  GroupingTypeOfVariableCreateDto,
  GroupingTypeOfVariableUpdateDto,
  GroupingTypeOfVariableExcelDownloadDto
> {
  service = inject(GroupingTypeOfVariableService);
  config = GROUPINGTYPEOFVARIABLE_CONFIG;
  fields = GROUPINGTYPEOFVARIABLE_FIELDS;

  protected prepareUpdateDto(data: any, selected: GroupingTypeOfVariableDto): GroupingTypeOfVariableUpdateDto {
    return {
      name: data.name,
      code: data.code,
      tariffsModuleId: data.tariffsModuleId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'GroupingTypeOfVariable';
  }
}
